var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "estimate-text-container" }, [
      _c("div", [
        _c("span", { staticClass: "estimate-text" }, [
          _vm._v(
            _vm._s(
              _vm.resource(
                "AudienceManager_Builder_Overview_ExpectedAudienceSize"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "estimate-updated" }, [
          _vm._v(
            "(" +
              _vm._s(
                _vm.resource(
                  "AudienceManager_Builder_Overview_EstimateLastUpdated"
                )
              ) +
              " " +
              _vm._s(_vm.audienceProgressLastRetrievedDisplay) +
              ")"
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "span",
        { staticClass: "estimate-number" },
        [
          _vm.hasTotal
            ? [_vm._v(_vm._s(_vm._f("readableNumber")(_vm.totalValue)))]
            : [
                _vm._v(
                  _vm._s(
                    _vm.resource(
                      "AudienceManager_Builder_Overview_EstimateUnknown"
                    )
                  )
                )
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }